import { z } from "zod";
import { defineExperiment } from "../defineExperiment";

export const WEB_OB_AI_MAR_24 = defineExperiment("WEB_OB_AI_MAR_24", {
  experience: z.enum(["control", "short_ob", "ai_based", "ai_based_short"]).default("control"),
});
